import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./search.css";
import profile from "../../assets/images/profile.jpg";
import Loading from "../../assets/images/loading.gif";
import SearchBlue from "../../assets/images/blue_search.png";

function SearchBar(props) {
  const SearchSuggestion = () => {
    if (props.data == "loading") {
      return (
        <div className="loading-image">
          <img src={Loading}></img>
        </div>
      );
    } else {
      if (props.data.length > 0) {
        return props.data.map((element, index) => {
          var uid = element.UserID;
          return (
            <>
              <div className="hd-search-name" key={index}>
                <div className="hd-search-name-si">
                  <div className="hd-search-name-img">
                    <img
                      src={
                        process.env.REACT_APP_IMG_URL +
                        (element.UserImage ? element.UserImage : "no-img.png")
                      }
                    />
                  </div>
                  <div className="hd-search-name-txt">
                    <NavLink
                      activeclassName="pp-profile-name-nav"
                      style={{ textDecoration: "none", color: "black" }}
                      to={"/profile/" + uid}
                    >
                      <h6>{element.UserName}</h6>
                      <p>{element.UserTeam} Team</p>
                    </NavLink>
                  </div>
                </div>
              </div>
            </>
          );
        });
      } else {
        return (
          <div className="hd-search-name">
            <div className="hd-search-nouser-si">
              <div className="hd-search-nouser-txt">
                <p>No User Found</p>
              </div>
            </div>
          </div>
        );
      }
    }
  };

  return (
    <div className="hd-searchBar">
      <SearchSuggestion />
      <div className="hd-search-end">
        <div className="hd-search-end-img">
          <img src={SearchBlue} />
        </div>
        <div className="hd-search-end-txt">
          <p>Search Results for {props.txt}</p>
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
